export const frCHTranslations = {
    navbar: {
        restaurant_location: "Itinéraire vers l'établissement",
        make_reservations: "Faire une réservation",
        search_product: "Rechercher un produit",
        call_waiter: "Appeler le serveur",
        change_language: "Changer de langue",
        feedback: "Évaluez-nous",
        about_tabl: "À propos de TABL",
    },

    pages: {
        products: {
            choose: "Choisir",
            choose_ingredients: "Choisir les ingrédients",
            choose_variant: "Veuillez choisir",
            alergens: "Allergènes",
            minimum_durability: "Durée de conservation minimale : jusqu'à {value} heures après la préparation",
            out_of_stock: "Indisponible",
            variant_not_choosed: "Vous n'avez pas choisi de variante !",
            min_count_addable_ingredients_reached: "Vous devez choisir au moins {value} suppléments !",
            max_count_addable_ingredients_reached: "Vous ne pouvez pas choisir plus de {value} suppléments !",
            additional_options: "Options supplémentaires",
            addable_options: "Suppléments",
            removable_options: "Retirer",
            comment: "Commentaire sur le produit",
            related_products: "Autres suggestions",
            add: "Ajouter",
            add_to_cart: "Ajouter au panier",
            choose_size: "Choisissez",
            save_for_order: "Sauvegarder pour la commande",
            order_disabled: "Ce produit ne peut pas être commandé actuellement !",
            book: "Réserver"
        },
        change_language: {
            title: "Veuillez choisir une langue",
        },
        call_waiter: {
            clean_table: "Veuillez nettoyer la table",
            new_cutlery: "Veuillez apporter de nouveaux couverts",
            more_napkins: "Veuillez apporter plus de serviettes",
            change_ashtray: "Veuillez changer le cendrier",
            bring_ice: "Veuillez apporter de la glace",
            other: "Autre",
        },
        feedback: {
            title: "Prenez une minute pour nous évaluer",
            customer_reviews: "Avis des clients",
            no_reviews_yet: "Soyez l'un des premiers à évaluer ce service.",
            choose_waiter: "Choisissez qui vous a servi :",
            what_went_wrong: "Nous sommes désolés ! Qu'est-ce qui n'allait pas ?",
            already_rated: "Vous avez déjà laissé une évaluation récemment. Merci !",
            google_review_title: "Nous sommes ravis que tout se soit bien passé !",
            google_review_button: "Évaluez-nous sur Google"
        },
        about_tabl: {
            title: "Ce service vous parvient grâce à ",
            sub_title: "Si vous avez besoin de plus d'informations sur la plateforme TabL, veuillez nous contacter.",
            about_link: "https://tabl.bg/"
        },
        cart_delivery: {
            minimal_order_price: "Le prix minimum pour une commande avec livraison est de {value}",
            price_according_to_region: "Prix selon la région",
            payment_type_room: "Mode de paiement pour le service en chambre",
            payment_type_pickup: "Mode de paiement pour le retrait sur place",
            payment_type_delivery: "Mode de paiement pour la livraison",
            cutlery_needed: "Souhaitez-vous des couverts ?",
            how_many_cutlery_needed: "Combien de couverts souhaitez-vous ?",
            cutlery_needed_yes: "Oui, j'aimerais",
            cutlery_needed_no: "Non, merci",
            region: "Région",
            now: "Maintenant",
            call_waiter_to_order: "Veuillez appeler le serveur pour commander",
            you_can_order_between: "Vous pouvez commander de {from} à {to} et de {from_two} à {to_two}",
            restaurant_closed_label: "Nous n'acceptons pas de commandes actuellement. Merci de votre compréhension !",
            restaurant_closed_label_day: "Nous n'acceptons pas de commandes actuellement, veuillez réessayer {day}: {value}",
            restaurant_closed_label_tommorow: "Nous n'acceptons pas de commandes actuellement, veuillez réessayer demain à {value}",
            restaurant_closed_label_today: "Nous n'acceptons pas de commandes actuellement, veuillez réessayer plus tard à {value}",
            closed_today_exception: "Nous n'acceptons pas de commandes actuellement, veuillez réessayer",
            closed_today: "Fermé aujourd'hui",
            next_working_day: "Prochain jour ouvrable",
            tomorrow: "demain à",
            on_day: "le",
            delivery_price: "Prix de livraison",
            delivery_price_is_not_included: "+ prix de livraison",
            cart: "Panier",
            no_cart_items: "Aucun produit ajouté au panier",
            orders: "Commandé",
            order: "Commande",
            min_delivery_price_text: 'Pour les commandes de plus de {value}, la livraison est gratuite',
            no_order_items: "Vous n'avez aucune commande active actuellement",
            order_placed_success: "Votre commande a été passée avec succès ! Vous pouvez suivre son statut ci-dessous.",
            total: "Prix",
            total_bill: "Total",

            status_ordered: 'Acceptée',
            status_cooked_spot: 'Préparée',
            status_cooked_delivery: 'Préparée',
            status_cooked_preorder: 'En attente du client',
            status_served_spot: 'Servie',
            status_on_the_way_delivery: 'En livraison',
            status_paid: 'Terminée',
            rejected: 'Refusée',

            pay_in_cash: "Payer en espèces",
            pay_with_card: "Payer par carte",
            make_order: "Commander",
            make_order_simple: "Commander",
            want_the_bill: "Demander l'addition",
            finish_bill: "Finaliser l'addition",
            kiosk_idle_title: "Êtes-vous toujours là ?",
            kiosk_idle_text: "Retour à l'écran d'accueil dans {seconds} s",
            kiosk_idle_continue: "Oui, continuer",
            make_delivery_order: "Commander avec livraison",
            choose_order_type: "Choisissez le mode de commande",
            choose_payment_type: "Choisissez le mode de paiement",
            payment_cash: "En espèces",
            payment_card: "Par carte",
            payment_epay: "En ligne",
            payment_online: "En ligne",
            payment_cash_delivery: "En espèces",
            payment_card_delivery: "Par carte à la livraison",
            payment_epay_delivery: "En ligne",
            payment_on_room_bill: "Sur la chambre",
            payment_online_delivery: "En ligne",
            "payment_online.bizum": "Bizum",
            "payment_online.bizum_delivery": "Bizum",
            delivery_price_included_in_total_price: "Avec prix de livraison inclus {delivery_price_num} pour les commandes jusqu'à {min_price_free_delivery_num}",
            order_type_restaurant: "Au restaurant",
            scan_barcode: "Scanner le code QR",
            order_type_delivery: "Livraison à domicile",
            order_type_preorder: "Retirer sur place",
            order_type_room: "Commander depuis la chambre",
            order_type_served_on_spot: "Commander pour consommation sur place",
            order_from_room: "Commande depuis la chambre",
            first_and_last_name: "Prénom et Nom",
            phone: "Numéro de téléphone",
            order_address: "Adresse: rue n° étage app. ville",
            delivery_time: "Date et heure de retrait",
            delivery_address: "Adresse de retrait",
            room_number: "Numéro de chambre",
            table: "Table",
            room: "Chambre",
            email: "Email",
            remember_me: "Se souvenir de moi",
            promo_code: "Code promo",
            promo_code_placeholder: "Code promo...",
            apply: "Appliquer",
            cancel: "Annuler",
            bill_already_wanted: "/votre addition a été demandée/",
            clear: "Effacer",
            close: "Fermer",
            save: "Sauvegarder",
            save_and_add: "Sauvegarder et Ajouter",
            fast_order: "Commande rapide",
            in_the_region_delivery: "Je me trouve dans la région de {region}",
            no_saved_addresses_with_that_name: 'Vous n\'avez pas d\'adresses sauvegardées avec ce nom, ajoutez-la depuis "Nouvelle adresse"',
            choose_pickup_place: "Choisissez un restaurant pour le retrait",
            choose_pickup_place_label: "Choisissez un restaurant",
            served_on_spot: "Servi sur place",
            choose_address: "Choisissez une adresse",
            add_new_address: "Nouvelle adresse",
            choose_delivery_address: "Choisissez une adresse de livraison",
            type_address: 'Commencez à taper une adresse',
            recent_addresses: 'Adresses récentes :',
            choose_on_map: 'Choisir sur la carte',
            adjust_on_map: 'Ajuster sur la carte',
            choose_location: "Choisir l'emplacement",
            change_location: "Modifier l'emplacement",
            use_current_location: 'Utiliser ma position actuelle',
            coordinates: 'Coordonnées',
            not_delivering_to_address: 'Nous ne livrons pas à cette adresse',
            address_not_found: "Le système n'a pas pu trouver cette adresse. Veuillez réessayer",
            address_search_error: "Une erreur est survenue lors de la recherche de l'adresse. Veuillez réessayer",
            address_not_recognized: 'Nous ne trouvons pas cette adresse. Veuillez réessayer',
            floor_and_appartment: "Étage/app.",
            floor_short: "Ét.",
            appartment_short: "App.",
            street_number_short: "N°/Bloc",
            street_number_only_short: "N°",
            building_number_short: "Bl.",
            bell_short: 'Sonn.',
            entrance_short: 'Ent.'
        },
        search: {
            searchProduct: "Rechercher un produit",
            noSearchResults: "Aucun produit trouvé",
            noSearchDescription: "Veuillez modifier les critères pour trouver le produit qui vous convient !",
        },
        choose_place: {
            title: "Veuillez choisir un lieu"
        },
        promotions: {
            title: "Promotion"
        },
        profile: {
            title: "Mon profil",
            fullname: "Prénom et Nom",
            first_name: "Prénom",
            last_name: "Nom",
            email: "Email",
            phone: "Téléphone",
            address: "Adresse",
            change_password: "Changer le mot de passe",
            password: "Mot de passe",
            new_password: "Nouveau mot de passe",
            tabl_points: "Points TABL",
            tabl_points_info: "Collectez des points TABL avec chaque commande et préparez-vous à de super surprises ;)",
            my_profile: "Mon profil",
            profile: "Profil",
            logout: "Déconnexion",
            orders: "Mes commandes",
            set_waiter_table: "Définir une table pour la commande",
            change_waiter_table: "Changer de table pour la commande",
            edit_profile_success: "Vous avez modifié vos données avec succès :)",
            edit_profile_error: "Erreur. Veuillez réessayer"       
        },
        my_orders: {
            title: "Mes commandes",
            order_date: "Date de commande",
            products: "Produits",
            type: "Type",
            amount: "Montant",
            payment: "Paiement",
            status: "Statut",
            address: "Adresse",
            personal_data: "Données"
        },
        booking: {
            book: "Réserver",
            choose_time: "Choisir la date et l'heure",
            minutes: "min.",
            success_booking: "Réservation réussie. Vous recevrez un email de confirmation. Inscrivez-vous et vous pourrez suivre vos réservations ;)"
        }
    },
    orders: {
        statuses: {
            ordered: "Commandée",
            cooked_spot: 'Préparée',
            served_spot: 'Servie',
            cooked_delivery: 'Préparée',
            on_the_way_delivery: 'En livraison',
            cooked_preorder: 'Préparée',
            cooked_room: "Préparée",
            paid: "Payée",
            rejected: "Refusée"
        },
        paid_online: "Payée en ligne",
    },
    common: {
        tip: 'Pourboire',
        custom_amount: 'Autre montant',
        no_tip: 'Pas de pourboire',
        discount_online_payments: 'Remise paiement en ligne',
        hi: "Salut",
        home: "Accueil",
        free_del: "Gratuite",
        amount: "Montant",
        subtotal: "Sous-total",
        final_price: "Prix final",
        no_internet: "Pas de connexion Internet.",
        count: 'pcs.',
        box: "boîte",
        change_place: 'Changer d\'établissement',
        current_place: 'Établissement actuel',
        like_us: "Aimez-nous",
        follow_us: "Suivez-nous",
        youtube: "YouTube",
        tipadvisor: "Tripadvisor",
        about: 'À propos',
        about_us: 'À propos de nous',
        discount: 'Remise',
        personal_discount: 'Remise personnelle',
        discount_promocode: 'Remise Code promo',
        delivery: 'Livraison',
        book: 'Réserver',
        language: 'Langue',
        navigate_me: "M'emmener",
        navigation: 'Navigation',
        search: 'Rechercher',
        call_us: 'Appelez-nous',
        options: 'Options',
        open: 'Ouvrir',
        product: "produit",
        products: "produits",
        user: "Utilisateur",
        choose: 'Veuillez choisir',
        comment: "Commentaire",
        contacts: "Contacts",
        working_hours: "Heures d'ouverture",
        payment_methods: "Mode de paiement",
        gallery: "Galerie",
        change_table: "Changer de table",
        clear_cart: "Vider",
        modify_ingredients: "Modifier les ingrédients",
        about_page_facilities: "Commodités",
        about_page_household: "Ménage",
        about_page_technical_support: "Support technique",
        boxes_prices: "Boîte",
        refund_policy: "Politique de remboursement",
        date: {
            today: "Aujourd'hui",
            tommorow: "Demain",
            day: {
                1: 'Lundi',
                2: 'Mardi',
                3: 'Mercredi',
                4: 'Jeudi',
                5: 'Vendredi',
                6: 'Samedi',
                7: 'Dimanche',
            }
        },

        action: {
            send: "Envoyer",
            skip: "Ignorer",
            back: "Retour",
        },

        label: {
            describe_here: "Décrire ici",
        },

        price_with_discount: "Prix avec remise",
        subscribe_for_lunch_menu: "Recevez les offres déjeuner de TABL",
        cart: 'Panier',
        profile: "Profil",
        login_or_register: "Connexion / Inscription",
        close: "Fermer",
        terms_for_use: "Conditions d'utilisation",
        privacy_policy: "Politique de confidentialité",
        i_read_and_agree_with: "J'ai lu et je suis d'accord avec ",
        i_agree_with: "Je suis d'accord avec",
        currency_bgn: " CHF",
        add_btn: "Ajouter",
        order_comment: "Commentaire sur la commande",
        order_modal_agree_with: "En créant la commande, vous acceptez nos ",
        and: ' et',
        cutleries: "Couverts",
        save: "Sauvegarder",
        to_the_menu: "Vers le menu"
    },

    messages: {
        notifications: {
            waiter_notified_successfully: 'Le serveur a été notifié avec succès',
            order_sent_success: "Votre commande a été acceptée avec succès.",
            feedback_thanks: "Merci du temps accordé !",
            bill_wanted_success: 'Votre addition a été demandée avec succès.',
            user_need_success: 'Votre demande a été reçue et est en cours de traitement',
            create_order_first: "Il est nécessaire de faire d'abord une commande",
            bill_already_wanted: "Votre addition a déjà été demandée",
            reset_password_success: "S'il existe un profil avec cet email, vous recevrez des instructions pour changer le mot de passe :)",
        },
        errors: {
            invalid_privacy_policy_and_terms: "Il est nécessaire d'accepter notre politique de confidentialité et les conditions générales",
            invalid_privacy_policy: "Il est nécessaire d'accepter notre politique de confidentialité",
            invalid_terms: "Il est nécessaire d'accepter les conditions générales",
            invalid_email: 'Veuillez saisir un email valide',
            invalid_password: 'Veuillez saisir un mot de passe valide',
            invalid_paddword_min: 'Veuillez saisir un mot de passe d\'au moins {value} caractères',
            invalid_name: 'Veuillez saisir un nom valide /de 3 à 40 caractères/',
            invalid_phone: 'Veuillez saisir un téléphone valide',
            invalid_phone_min: 'Veuillez saisir un téléphone d\'au moins {value} caractères',
            invalid_field: 'Veuillez saisir des informations dans le champ',
            invalid_address: 'Veuillez saisir une adresse valide',
            invalid_regionId: 'Veuillez choisir une région',
            invalid_orderDate: 'Veuillez saisir une date de retrait',
            invalid_orderTime: 'Veuillez saisir une heure de retrait',
            invalid_room_number: 'Veuillez saisir un numéro de chambre',
            invalid_payment_method: 'Veuillez choisir une méthode de paiement',
            invalid_cutlery_selected: "Veuillez choisir si vous souhaitez des couverts",
            invalid_additional_order_type: "Veuillez choisir le type de commande",
            invalid_text_comment: "Veuillez saisir un commentaire valide jusqu'à 500 caractères",
            invalid_fields: "Veuillez remplir tous les champs correctement",
            order_sent_fail: "Veuillez scanner à nouveau !",
            bill_wanted_fail: "Oups, l'addition ne peut pas être demandée !",
            user_need_fail: 'Oups, une erreur s\'est produite lors de l\'envoi de la demande',
            "Too many requests, please try again later.": "Vous avez atteint la limite de demandes pour le moment. Veuillez réessayer plus tard",
            "Invalid phone": "Téléphone invalide",
            "Invalid name": "Nom invalide",
            error: "Erreur",
            invalid_pickup_place: 'Veuillez choisir un établissement pour le retrait',

            invalid_street_number: "Entrez le numéro de rue ou de bloc",
            invalid_street_number_length: "Le numéro est trop long",
            invalid_street_number_required: "Numéro de rue manquant",
            invalid_building_number: "Numéro de bloc manquant",
            invalid_building_number_length: "Le numéro de bloc est trop long",

            invalid_floor_number: "Numéro d'étage manquant",
            invalid_floor_number_length: "Le numéro est trop long",

            invalid_ap_number: "Numéro d'appartement manquant",
            invalid_ap_number_length: "Le numéro est trop long",

            invalid_bell_number: "Numéro de sonnette manquant",
            invalid_bell_number_length: "Le numéro est trop long",
            invalid_entrance_number: "Numéro d'entrée manquant",
            invalid_entrance_number_length: "Le numéro est trop long",
            invalid_required_checkbox_in_order_modal: "Vous devez accepter",
            invalid_required_checkbox_in_order_modal_2: "Vous devez accepter",

            please_try_again: "Veuillez réessayer.",
            too_mony_orders_for_session_in_x_seconds: "Vous essayez d'envoyer la même commande plusieurs fois. Veuillez réessayer dans quelques secondes",
            invalid_delivery_shape: "Veuillez vérifier l'adresse de livraison ou la saisir à nouveau",
            invalid_region_for_place: "Veuillez vérifier la région de livraison ou la sélectionner à nouveau",
            orders_not_allowed: "Nous n'acceptons pas de commandes actuellement. Veuillez réessayer plus tard.",
            invalid_products_for_place: "Vous essayez de commander des produits d'un autre établissement. La page sera rechargée. Veuillez commander à nouveau. Nous nous excusons pour la gêne occasionnée :)",
            place_not_active: "Le menu a été mis à jour. La page sera rechargée. Veuillez commander à nouveau. Nous nous excusons pour la gêne occasionnée :)",
            error_sending_order: "Une erreur s'est produite lors de l'envoi de la commande !",
            please_scan_qr_code_to_order: "Veuillez scanner le code QR pour commander."
        }
    },

    modals: {
        upselling_products: {
            title: "Et pourquoi ne pas essayer aussi"
        },
        language_modal: {
            back_to_default_lang: "Vers la langue par défaut",
            translations_may_not_be_accurate: "Le texte traduit peut ne pas être complètement précis"
        },
        initial_html_banner: {
            title: "Bienvenue",
            to_the_menu: "Vers le menu"
        },
        add_to_home_screen: {
            title: "Ajoutez le menu à votre écran d'accueil",
            body: "Ouvrez-le comme une application — plein écran, instantané, sans recherche.",
            ios_title: "Ajoutez le menu à votre écran d'accueil",
            ios_body: "Appuyez sur « Partager » en bas, puis choisissez « Sur l'écran d'accueil ».",
            ios_chrome_body: "Appuyez sur l'icône « Partager » dans la barre d'adresse, puis choisissez « Sur l'écran d'accueil ».",
            ios_other_body: "Ouvrez le menu du navigateur, appuyez sur « Partager », puis choisissez « Sur l'écran d'accueil ».",
            install: "Ajouter",
            close: "Fermer"
        }
    },

    promocode: {
        others_discounts_are_not_applied: "En utilisant ce code promo, toutes les autres remises (s'il y en a) NE s'appliquent PAS"
    },

    payments: {
        choose_payment_method: "Mode de paiement",
        processing: "Le paiement est en cours de traitement",
        payment_failed: "Paiement échoué. Veuillez réessayer.",
        payment_success: "Commande passée avec succès"
    },
    login: {
        log_in_your_profile: "Connectez-vous à votre profil",
        save_your_data: "et sauvegardez vos données",
        login_btn: "Connexion",
        register_if_no_profile: "Vous n'avez pas de profil ? Inscrivez-vous",
        forgot_password: "Vous avez oublié votre mot de passe ?",
        login_success: "Vous vous êtes connecté avec succès à votre profil",
        logout_success: "À bientôt :(",
        login_fail: "Données de connexion invalides"
    },
    register: {
        register: "S'inscrire",
        collect_tabl_points: "et collectez des points TabL",
        register_btn: "S'inscrire",
        already_have_account: "Vous avez déjà un profil ? Connectez-vous",
        successful_registration: "Inscription réussie. Veuillez vous connecter à votre compte :)"
    },
    forgot_password: {
        forgot_password: "Mot de passe oublié",
    },
    accumulated_order_amount: {
        use: "Utiliser",
        remove: "Retirer",
        register_for_discount: "Inscrivez-vous et accumulez de l'argent avec chaque commande",
        you_have_accumulated: "Vous avez accumulé",
        no_accumulated_money_text: "Commandez et économisez sur votre prochaine commande",
        register_and_accumulate: "Inscrivez-vous et gagnez",
        for_you_next_order: "pour votre prochaine commande",
        complete_your_order_and_accumulate: "Terminez votre commande et gagnez",
        profile_text: "Argent accumulé des commandes",
        profile_description: "À chaque commande, un % du montant s'accumule dans votre profil. Lors du prochain achat, vous avez la possibilité de l'utiliser :)"
    }
}